import React from 'react';
import { useAppContext } from '../../AppContext';

const withVisionAura = (WrappedComponent) => {
    return (props) => {
        const { visions } = useAppContext();
        const hasActiveVisions = visions.some(vision => vision.userId === props.userId && new Date(vision.expiresAt.seconds * 1000) > new Date());

        return (
            <div className={`relative ${hasActiveVisions ? 'vision-aura' : ''}`}>
                <WrappedComponent {...props} />
            </div>
        );
    };
};

export default withVisionAura;
